import React from 'react';

import Trophy from '@rover/icons/svg/trophy.svg';

import InfoBox from './InfoBox';

const ICON_SIZE = 24;

type YearsOfExperienceProps = {
  yearsOfTraining: number;
  isTrainerProfileReordering?: boolean;
};

const YearsOfExperience: React.FC<YearsOfExperienceProps> = ({
  yearsOfTraining,
  isTrainerProfileReordering = false,
}) => {
  // TODO (DEV-104195): Translate below text
  const yearsOfTrainingString: string = `${yearsOfTraining} years experience`;

  return (
    <InfoBox isTrainerProfileReordering={isTrainerProfileReordering}>
      <InfoBox.Icon>
        <Trophy width={ICON_SIZE} height={ICON_SIZE} />
      </InfoBox.Icon>
      <InfoBox.BoldText isTrainerProfileReordering={isTrainerProfileReordering}>
        {yearsOfTrainingString}
      </InfoBox.BoldText>
    </InfoBox>
  );
};

export default YearsOfExperience;
